export default __webpack_public_path__ + "static/curriculum-guide-preview-3-11b522587e6baac0a23a68132e9dd4cb.jpg";